"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _FullReportStatsFilter = _interopRequireDefault(require("./FullReportStatsFilter"));
var _SortDescriptor = _interopRequireDefault(require("./SortDescriptor"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The FullReportStatsQuery model module.
 * @module model/FullReportStatsQuery
 * @version 1.1.3-alpha.1
 */
class FullReportStatsQuery {
  /**
   * Constructs a new <code>FullReportStatsQuery</code>.
   * @alias module:model/FullReportStatsQuery
   */
  constructor() {
    FullReportStatsQuery.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>FullReportStatsQuery</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FullReportStatsQuery} obj Optional instance to populate.
   * @return {module:model/FullReportStatsQuery} The populated <code>FullReportStatsQuery</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new FullReportStatsQuery();
      if (data.hasOwnProperty('filter')) {
        obj['filter'] = _FullReportStatsFilter.default.constructFromObject(data['filter']);
      }
      if (data.hasOwnProperty('sorting')) {
        obj['sorting'] = _ApiClient.default.convertToType(data['sorting'], [_SortDescriptor.default]);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>FullReportStatsQuery</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FullReportStatsQuery</code>.
   */
  static validateJSON(data) {
    // validate the optional field `filter`
    if (data['filter']) {
      // data not null
      _FullReportStatsFilter.default.validateJSON(data['filter']);
    }
    if (data['sorting']) {
      // data not null
      // ensure the json data is an array
      if (!Array.isArray(data['sorting'])) {
        throw new Error("Expected the field `sorting` to be an array in the JSON data but got " + data['sorting']);
      }
      // validate the optional field `sorting` (array)
      for (const item of data['sorting']) {
        _SortDescriptor.default.validateJSON(item);
      }
      ;
    }
    return true;
  }
}

/**
 * @member {module:model/FullReportStatsFilter} filter
 */
FullReportStatsQuery.prototype['filter'] = undefined;

/**
 * @member {Array.<module:model/SortDescriptor>} sorting
 */
FullReportStatsQuery.prototype['sorting'] = undefined;
var _default = exports.default = FullReportStatsQuery;